<div class="chips-input-container" [ngClass]="[size, error ? 'error' : '']">
  @if (label) {
    <label [for]="chipsInputId" class="chips-input-label">{{ label }}</label>
  }

  <div class="chips-input-wrapper" [ngClass]="{ 'disabled': disabled }">
    <!-- Chips -->
    @for (chip of value; track $index) {
      <app-chip
        [label]="chip"
        [removable]="!disabled"
        [size]="chipSize"
        (onRemove)="removeChip($index)"
      />
    }

    <!-- Input -->
    <input
      [id]="chipsInputId"
      type="text"
      class="chips-input-field"
      [placeholder]="value && value.length ? '' : placeholder"
      [disabled]="disabled"
      [value]="currentChip"
      (input)="onInputChange($event)"
      (keydown)="handleKeydown($event)"
    />
  </div>

  @if (error && errorMessage) {
    <div class="error-message">{{ errorMessage }}</div>
  }
</div>